import React from 'react'
import { trackBookingClick } from '../lib/tracking'

export default function WhatHappens() {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-20 bg-white animate-on-scroll">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-light mb-8 text-[#2c3424] text-center">
          Što se događa na konzultacijama
        </h2>
        <div className="space-y-6 text-[#1a1a1a] leading-relaxed">
          <p className="text-lg">
            Konzultacije su strukturiran proces osmišljen da vam pruži potpunu jasnoću:
          </p>
          <ul className="space-y-4 text-lg ml-6">
            <li className="flex items-start">
              <span className="mr-3 text-[#2c3424] font-bold">•</span>
              <span><strong>Procjena kože i dlačica:</strong> kozmetičar procjenjuje tip vaše kože i karakteristike dlačica kako bi utvrdio prikladnost tretmana.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-[#2c3424] font-bold">•</span>
              <span><strong>Medicinska povijest i kontraindikacije:</strong> razgovor o zdravstvenoj povijesti i lijekovima radi sigurnosti laserskog tretmana.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-[#2c3424] font-bold">•</span>
              <span><strong>Test na malom području (ako je potrebno):</strong> tretira se manje testno područje kako bi se provjerila moguća reakcija.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-[#2c3424] font-bold">•</span>
              <span><strong>Personalizirani plan tretmana:</strong> preporučuje se broj tretmana i razmaci između njih prema vašim potrebama.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-[#2c3424] font-bold">•</span>
              <span><strong>Objašnjenje cijena i paketa:</strong> pregled dostupnih paketa i odgovori na pitanja o cijeni.</span>
            </li>
            <li className="flex items-start">
              <span className="mr-3 text-[#2c3424] font-bold">•</span>
              <span><strong>Vrijeme za pitanja:</strong> klijenti mogu pitati sve o pripremi, njezi nakon tretmana ili očekivanim rezultatima.</span>
            </li>
          </ul>
          <p className="text-lg">
            Konzultacije su besplatne i ne obvezuju vas na ništa.
          </p>
        </div>
        
        <div className="text-center mt-12">
          <div className="button-wrapper inline-block">
            <a 
              href="https://medispahr.wixforms.com/f/7479898417246766083"
              target="_blank"
              rel="noopener noreferrer"
              data-cta="book_now"
              data-cta-location="what_happens"
              onClick={() => trackBookingClick('what_happens')}
              className="guten-button guten-button-sm inline-block px-8 py-4 bg-[#768064] text-white text-base font-medium rounded transition-colors duration-300 hover:bg-[#5d6950]"
            >
              <span>Rezerviraj besplatnu konzultaciju</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
